<div class="new-request-container" [class.fullscreen]="isFullscreen$ | async">
	<form [formGroup]="requestForm" class="form au-forms">
		<au-cmms-entity-name
			[editMode]="true"
			[disablePreview]="true"
			[autofocusEnabled]="true"
			(controlReady)="addChildControl('name', $event)"
			namePreviewClasses="m-b-sxs"
		></au-cmms-entity-name>

		<cmms-autocomplete-contact
			(controlReady)="addChildControl('requestees', $event)"
			namePreviewClasses="m-b-sxs"
			[editMode]="true"
			[newRequesteeForm]="true"
		></cmms-autocomplete-contact>
		<div class="m-b-xs">
			<cmms-locations-section
				[locationsInputList]="requestForm.value?.locations"
				(controlReady)="addChildControl('locations', $event)"
				[isRequired]="true"
			></cmms-locations-section>
		</div>

		<div class="priority-and-category">
			<cmms-priority-level
				class="priority"
				(controlReady)="addChildControl('priority', $event)"
			></cmms-priority-level>

			<cmms-entity-category
				class="category"
				(controlReady)="addChildControl('category', $event)"
			></cmms-entity-category>
		</div>

		<div class="assignee-section m-b-sm">
			<cmms-assignee-and-approver
				(assigneeControlReady)="addChildControl('assignee', $event)"
				(approverControlReady)="addChildControl('approver', $event)"
			></cmms-assignee-and-approver>
		</div>

		<div class="m-b-m">
			<cmms-labels-section (controlReady)="addChildControl('labels', $event)" />
		</div>

		<div class="description m-b-m">
			<cmms-description
				[isRequired]="false"
				(controlReady)="addChildControl('description', $event)"
			></cmms-description>
		</div>

		<div class="sections">
			<entity-section
				[entityType]="cmmsPages.editIncident"
				(addNewEntityItem)="navigateTo($event)"
				(addExistingEntityItem)="navigateToExist($event)"
				[tableData]="requestForm?.value?.incidents || []"
				[tableColumns]="tableConfig"
				(unlink)="unlinkItem($event.data, 'incidents')"
				(rowSelect)="viewSelected($event)"
			>
			</entity-section>
			<entity-section
				[entityType]="cmmsPages.editWorkOrder"
				(addNewEntityItem)="navigateTo($event)"
				(addExistingEntityItem)="navigateToExist($event)"
				[tableData]="requestForm?.value?.workOrders || []"
				[tableColumns]="tableConfig"
				(unlink)="unlinkItem($event.data, 'workOrders')"
				(rowSelect)="viewSelected($event)"
			>
			</entity-section>
			<assets-section
				(openAssets)="openAssets()"
				(newAsset)="navigateTo($event)"
				(rowSelect)="viewSelected($event.data)"
				(unlink)="unlinkItem($event.data, 'assets')"
				[assets]="requestForm?.value?.assets || []"
			>
			</assets-section>
		</div>

		<div class="sections">
			<au-file-loader
				[loadedFiles]="requestForm?.value?.files"
				[delegateDeleting]="true"
				[askDeleting]="false"
				[fullFileLoadData]="true"
				[cardsView]="true"
				(addExistingFileClicked)="navigateToExist($event)"
				(fullFileLoaded)="fileListChanged($event)"
				(filesDeleted)="filesDeleted($event)"
				[options]="fileLoaderOptions"
				(rowSelect)="viewSelected($event)"
			></au-file-loader>
		</div>
	</form>
</div>
